import Vue from 'vue'
import App from './AppLanguages'

import store from './store/languages'
import router from './router/languages'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main-languages.js